var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8337 14.7732V15.9999C29.832 18.8751 28.901 21.6728 27.1794 23.9757C25.4579 26.2785 23.038 27.9632 20.2808 28.7784C17.5236 29.5937 14.5767 29.4958 11.8796 28.4993C9.18257 27.5029 6.87986 25.6614 5.31494 23.2493C3.75001 20.8373 3.00671 17.984 3.19589 15.115C3.38508 12.246 4.4966 9.515 6.3647 7.32933C8.2328 5.14366 10.7574 3.62041 13.5619 2.98676C16.3664 2.35311 19.3007 2.64302 21.927 3.81323",
    stroke: "#34D058",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8333 5.33325L16.5 18.6799L12.5 14.6799",
    stroke: "#34D058",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.b81c7d4d13a17b13dc720bd5c479f0bb.svg";
export { ForwardRef as ReactComponent };